import { render, staticRenderFns } from "./NameList.vue?vue&type=template&id=699f0e4a&scoped=true&"
import script from "./NameList.vue?vue&type=script&lang=js&"
export * from "./NameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699f0e4a",
  null
  
)

export default component.exports